__turbopack_context__.v({
  "textCenter": "TextCenter-module__h8Gd6q__textCenter",
});
